import DOMPurify from 'dompurify'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import CloseSVG from '../../../../assets/svg/close.svg'
import { formValidation } from '../../../../utils/functions'
import Button from '../../../button'
import FormTextArea from '../../../form-textarea'
import FormSelectEmployee from '../../../employees/form-select-employee'
import {
  useAddQuery,
  useEditQuery,
} from '../../../../redux/human-resources/hook/queries'
import Modal from '../../modal'
import FormInput from '../../../form-input'
import { setAlert } from '../../../../redux/components/components-slice'
import { useDispatch } from 'react-redux'
import TrackQuery from './TracKQuery'

function AddQuery({
  isOpen,
  setShowAddQuery,
  refetchQueries,
  title,
  buttonText,
}) {
  const {
    register,
    handleSubmit,
    formState: { isValid },
    errors,
  } = useForm({
    mode: 'onChange',
  })

  const dispatch = useDispatch()
  const [queryData, setQueryData] = useState(null)
  const [trackQuery, setTrackQuery] = useState(false)

  const [query, setQuery] = useState('')
  const [employee, setEmployee] = useState()
  const [employeeName, setEmployeeName] = useState()

  const { mutateAsync: addQuery, isLoading: addQueryloading } = useAddQuery()
  const { mutateAsync: editQuery, isLoading: editQueryloading } = useEditQuery()

  const submitForm = async (data) => {
    const query = DOMPurify.sanitize(data?.query)
    const subject = DOMPurify.sanitize(data?.subject)

    let payload = {
      employee_id: employee,
      subject,
      query,
    }

    if (!employee) {
      dispatch(setAlert(true, 'info', 'Select an employee'))
      return
    }

    // if (queryType === 'add') {
    await addQuery(payload).then((response) => {
      refetchQueries()
      setQueryData(response?.data)
      setTrackQuery(true)
    })
    // }

    // else if (queryType === 'edit') {
    //   let editPayload = {
    //     id: queryId,
    //     data: payload,
    //   };
    //   await editQuery(editPayload).then(() => {
    //     closeModal();
    //   });
    // }
  }

  return (
    <>
      {trackQuery ? (
        <TrackQuery
          isOpen={trackQuery}
          setTrackQuery={setTrackQuery}
          query={queryData}
          setShowAddQuery={setShowAddQuery}
        />
      ) : null}

      <Modal
        scrollable={true}
        className='!max-w-[600px] !rounded-none'
        isOpen={isOpen}
        centered={true}
      >
        <div className='flex flex-col overflow-auto'>
          <form className='form pb-4' onSubmit={handleSubmit(submitForm)}>
            <div className='pl-8 pr-8 pt-4'>
              <div className='flex flex-row justify-between items-center'>
                <span className='header-4'>{title}</span>
                <div
                  className='cursor-pointer'
                  onClick={() => setShowAddQuery(false)}
                >
                  <img src={CloseSVG} alt='close' />
                </div>
              </div>
            </div>
            <hr className='divider' />
            <div className='flex flex-col mx-8'>
              <div>
                <div className='border bg-highlight p-2 rounded-md mb-2'>
                  <FormSelectEmployee
                    label={'Employee'}
                    name='employee'
                    placeholder='Type to select employee'
                    value={employee}
                    readOnly={addQueryloading}
                    empName={employeeName}
                    setEmployee={setEmployee}
                  />
                </div>
                <div className='w-full'>
                  <FormInput
                    label='Query Subject'
                    name='subject'
                    type='text'
                    placeholder={'Enter query subject'}
                    inputRef={register(formValidation('text', true))}
                    readOnly={addQueryloading}
                    error={errors.subject}
                    className={'!bg-white'}
                    errorMessage={errors.subject && errors.subject.message}
                  />
                </div>
                <FormTextArea
                  label={'Query Message'}
                  name='query'
                  type='text'
                  defaultValue={query}
                  onInput={(e) => {
                    setQuery(e.target.value)
                  }}
                  placeholder={'Enter the query here'}
                  inputRef={register(formValidation('text', true))}
                  readOnly={editQueryloading || addQueryloading}
                  error={errors.query}
                  errorMessage={errors.query && errors.query.message}
                />
              </div>
              <div className='w-full mt-[20px]'>
                <Button
                  text={buttonText}
                  type='submit'
                  disabled={!isValid}
                  loading={editQueryloading || addQueryloading}
                />
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  )
}

export default AddQuery
